import {
  EPsrCameraLiveImageAction,
  PsrCameraLiveImageAction,
  CursorOffset,
} from "../actions/PsrCameraLiveImageAction";
import { RootState } from "./RootReducer";

type State = {
  showCrosshair: boolean;
  showRuler: boolean;
  bestFit: boolean;
  liveImageCropZoomX: number;
  liveImageCropZoomY: number;
  cursorOffset: CursorOffset;
};

function getInitialState(): State {
  const showCrosshair = localStorage.getItem(
    EPsrCameraLiveImageAction.SET_SHOW_CROSSHAIR
  );
  const showRuler = localStorage.getItem(
    EPsrCameraLiveImageAction.SET_SHOW_RULER
  );
  const bestfit = localStorage.getItem(
    EPsrCameraLiveImageAction.SET_IMAGE_BEST_FIT
  );

  const initialState: State = {
    liveImageCropZoomX: 1,
    liveImageCropZoomY: 1,
    showCrosshair:
      showCrosshair != null ? showCrosshair.toLowerCase() === "true" : false,
    showRuler: showRuler != null ? showRuler.toLowerCase() === "true" : true,
    bestFit: bestfit != null ? bestfit.toLowerCase() === "true" : true,
    cursorOffset: { x: 0, y: 0 },
  };
  return initialState;
}

export function PsrCameraLiveImageReducer(
  state = getInitialState(),
  action: PsrCameraLiveImageAction
): State {
  switch (action.type) {
    case EPsrCameraLiveImageAction.SET_LIVE_IMAGE_CROP_ZOOM:
      if (action.liveImageCropZoomX == null) {
        throw new Error("liveImageCropZoomX is null");
      }
      if (action.liveImageCropZoomY == null) {
        throw new Error("liveImageCropZoomY is null");
      }
      return {
        ...state,
        liveImageCropZoomX: action.liveImageCropZoomX,
        liveImageCropZoomY: action.liveImageCropZoomY,
      };
    case EPsrCameraLiveImageAction.SET_SHOW_CROSSHAIR:
      if (action.showCrosshair == null) {
        throw new Error("ShowCrosshair is null");
      }
      localStorage.setItem(
        EPsrCameraLiveImageAction.SET_SHOW_CROSSHAIR,
        action.showCrosshair.toString()
      );
      return {
        ...state,
        showCrosshair: action.showCrosshair,
      };
    case EPsrCameraLiveImageAction.SET_SHOW_RULER:
      if (action.showRuler == null) {
        throw new Error("ShowRuler is null");
      }
      localStorage.setItem(
        EPsrCameraLiveImageAction.SET_SHOW_RULER,
        action.showRuler.toString()
      );
      return {
        ...state,
        showRuler: action.showRuler,
      };
    case EPsrCameraLiveImageAction.SET_IMAGE_BEST_FIT:
      if (action.bestFit == null) {
        throw new Error("BestFit is null");
      }
      localStorage.setItem(
        EPsrCameraLiveImageAction.SET_IMAGE_BEST_FIT,
        action.bestFit.toString()
      );
      return {
        ...state,
        bestFit: action.bestFit,
      };
    case EPsrCameraLiveImageAction.SET_CURSOR_OFFSET:
      if (action.cursorOffset == null) {
        throw new Error("CursorOffset is null");
      }
      return {
        ...state,
        cursorOffset: action.cursorOffset,
      };
    default:
      return state;
  }
}

export const getShowCrossHair = (state: RootState): boolean =>
  state.psrCameraLiveImageStore.showCrosshair;
export const getShowRuler = (state: RootState): boolean =>
  state.psrCameraLiveImageStore.showRuler;
export const getBestFit = (state: RootState): boolean =>
  state.psrCameraLiveImageStore.bestFit;
export const getCursorOffset = (state: RootState): CursorOffset =>
  state.psrCameraLiveImageStore.cursorOffset;
